/**
 * Input Sanitization – XSS-preventie
 * Strip HTML-tags en scripts uit gebruikersinvoer.
 */

import DOMPurify from 'dompurify'

export const MAX_NAME_LENGTH = 255
export const MAX_TEXT_LENGTH = 5000

export function sanitizeInput(input) {
  if (input == null || typeof input !== 'string') return ''
  const trimmed = input.trim()
  if (!trimmed) return ''
  return DOMPurify.sanitize(trimmed, { ALLOWED_TAGS: [] })
}

export function sanitizeName(input, maxLen = MAX_NAME_LENGTH) {
  const s = sanitizeInput(input)
  return s.length > maxLen ? s.slice(0, maxLen) : s
}

export function sanitizeHtml(dirty, options = {}) {
  if (dirty == null || typeof dirty !== 'string') return ''
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: ['href', 'target'],
    ...options,
  })
}
